module.exports = __webpack_public_path__ + "img/Remove-Zoom-Confirmation.e45cac7b.png";